import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import TaskModal from "@/components/layouts/TasksDrawer/TaskModal";
import { useFeatureFlag } from "@/services/features/hook";
import { FeatureFlags } from "@/services/features/types";

const TaskPage: React.FC = () => {
  const { taskId } = useParams<{ taskId: string }>();
  const navigate = useNavigate();
  const { enabled: showMyTasksPage } = useFeatureFlag(
    FeatureFlags.CRM_9035_MY_TASKS_PAGE
  );

  const [isTaskModalOpen, setIsTaskModalOpen] = useState(true);

  useEffect(() => {
    if (!isTaskModalOpen) {
      navigate(showMyTasksPage ? "/tasks" : "/");
    }
  }, [isTaskModalOpen, navigate, showMyTasksPage]);

  return (
    taskId && (
      <TaskModal
        isOpen={isTaskModalOpen}
        setIsOpen={setIsTaskModalOpen}
        isEditMode
        editTaskId={taskId}
      />
    )
  );
};

export default TaskPage;
